
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import headers from '@/components/loyaltyPrograms/headers';

@Component({
  components: { VTable },
})
export default class LoyaltyProgramsTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: any[];

  get headers() {
    return headers;
  }
}
